// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__274AC","title":"Header_title__32Kvo","side":"Header_side__1zNmc"};